import { ChangeDetectionStrategy, Component, input, output, ViewEncapsulation } from '@angular/core';
import { Itinerary } from '../../entities';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'ol[at-itinerary-list],at-itinerary-list',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './itinerary-list.component.html',
  styleUrl: './itinerary-list.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'itinerary',
  },
})
export class ItineraryListComponent {
  public itinerary = input.required<Itinerary>();
  public canContactExpert = input<boolean>(true);

  public shareEmail = output<boolean>();

  public shareEmailControl = new FormControl(false);
}
